import { DialogContentActionsClose } from "@datamole/wds-component-dialog";
import { isValidElement } from "react";

import { Button, ButtonProps } from "@/components/ui/button";
import { CloseIcon } from "@/components/ui/icon";

type Props = ButtonProps & {
    startIcon?: React.ReactNode | boolean;
};

const Close = (props: Props) => {
    const { children = "Close", variant = "outline", startIcon, ...otherProps } = props;

    const renderIcon = () => {
        if (startIcon === true) {
            return <CloseIcon />;
        } else if (isValidElement(startIcon)) {
            return startIcon;
        }
        return null;
    };

    return (
        <DialogContentActionsClose asChild>
            {}
            <Button {...otherProps} startIcon={renderIcon()} variant={variant}>
                {children}
            </Button>
        </DialogContentActionsClose>
    );
};

export { Close as DialogContentActionsClose };
export type { Props as DialogContentActionsCloseProps };
